import React, { useState, useRef, useEffect } from "react";
import {
  CreditCard,
  Upload,
  Download,
  FileText,
  Heart,
  RotateCcw,
} from "lucide-react";
import Mo3tiButton from "./Mo3tiButton";

const ActionButtons = ({
  t,
  styles,
  headerStyles,
  theme,
  modulePermissions,
  filteredPayrollData,
  setShowProcessModal,
  setShowImportModal,
  setShowMedicalInsuranceModal,
  setShowBenefitsModal,
  setShowBulkUnpayModal,
  handleAllowanceDeductionFileSelect,
  handleOpenAllowanceDeductionImport,
  handleShowTemplateDetails,
  handleShowImportDetails,
  handleExportAllowanceDeductionTemplate,
  handleExportPayrollPDF,
  handleExportPayrollExcel,
}) => {


  return (
    <>
      {/* Action Buttons */}
      <div style={{
        ...headerStyles,
        marginTop: "30px",
        background: theme === "dark" ? "transparent" : "#ffffff",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}>
        <input
          id="allowance-deduction-import-input"
          type="file"
          accept=".xlsx,.xls,.csv"
          style={{ display: "none" }}
          onChange={handleAllowanceDeductionFileSelect}
        />
        <div
          className="action-buttons-container"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "flex-start",
            alignItems: "center",
            //  padding: "24px",
          }}
        >
          {modulePermissions && modulePermissions.processPayroll && (
              <Mo3tiButton
                variant="primary"
                size="sm"
                icon={CreditCard}
                onClick={() => setShowProcessModal(true)}
                style={styles.primaryBtn}
                title={t("processPayroll")}
              >
                {t("processPayroll")}
              </Mo3tiButton>
            )}

          {modulePermissions && modulePermissions.processPayroll && (
              <Mo3tiButton
                variant="secondary"
                size="sm"
                icon={RotateCcw}
                onClick={() => setShowBulkUnpayModal(true)}
                style={styles.secondaryBtn}
                title={t("bulkUnpay")}
              >
                {t("bulkUnpay")}
              </Mo3tiButton>
            )}

          {modulePermissions &&
            modulePermissions.dataImport && (
              <Mo3tiButton
                variant="secondary"
                size="sm"
                icon={Upload}
                onClick={handleShowImportDetails}
                style={styles.secondaryBtn}
                title={t("import")}
              >
                {t("import")}
              </Mo3tiButton>
            )}

          {modulePermissions &&
            modulePermissions.dataExport && (
              <>
                <Mo3tiButton
                  variant="secondary"
                  size="sm"
                  icon={Download}
                  onClick={handleShowTemplateDetails}
                  style={styles.secondaryBtn}
                  title={t("templateButtonTitle")}
                >
                  {t("templateButton")}
                </Mo3tiButton>
                {/* <Mo3tiButton
                  variant="secondary"
                  size="sm"
                  icon={Download}
                  onClick={handleExportAllowanceDeductionTemplate}
                  style={styles.secondaryBtn}
                  title={t("exportAllowanceDeductionTemplatetitle")}
                >
                  {t("exportAllowanceDeductionTemplate")}
                </Mo3tiButton> */}
              </>
            )}

          {/* Download as PDF - independent permission only */}
          {filteredPayrollData && filteredPayrollData.length > 0 &&
            modulePermissions?.exportPayrollPDF && (
              <Mo3tiButton
                variant="secondary"
                size="sm"
                icon={FileText}
                onClick={handleExportPayrollPDF}
                style={styles.secondaryBtn}
                title={t("exportPayrollPDF")}
              >
                {t("exportPayrollPDF")}
              </Mo3tiButton>
            )}

          {/* Export to Excel - independent permission only */}
          {filteredPayrollData && filteredPayrollData.length > 0 &&
            modulePermissions?.exportPayrollExcel && (
              <Mo3tiButton
                variant="secondary"
                size="sm"
                icon={Download}
                onClick={() => handleExportPayrollExcel(filteredPayrollData)}
                style={styles.secondaryBtn}
                title={t("exportPayrollExcel")}
              >
                {t("exportPayrollExcel")}
              </Mo3tiButton>
            )}

          {/* Manage Visibility button removed per user request */}
          {modulePermissions?.medicalInsurance && (
            <Mo3tiButton
              variant="secondary"
              size="sm"
              icon={Heart}
              onClick={() => setShowMedicalInsuranceModal(true)}
              style={styles.secondaryBtn}
              title={t("medicalInsurance")}
            >
              {t("medicalInsurance")}
            </Mo3tiButton>
          )}

          
        </div>
      </div>

      {/* Statistics Grid */}
    </>
  );
};

export default ActionButtons;